<template>
    <div class="h-screen flex">
      <AppSidebar :isOpen="isSidebarOpen" @close="isSidebarOpen = false" />
      <div class="flex flex-col flex-1 min-w-0"> 
        <AppHeader :isSidebarOpen="isSidebarOpen" @toggleSidebar="toggleSidebar" />
        <main class="flex-1 overflow-auto bg-gray-100 text-primary-text dark:text-gray-100 border-light-border dark:bg-primary-dark-bg dark:border-dark-border p-4">
          <slot />
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import AppSidebar from '../components/AppSidebar.vue'
  import AppHeader from '../components/AppHeader.vue'
  
  export default {
    components: { AppSidebar, AppHeader },
    data() {
      return { isSidebarOpen: false }
    },
    methods: {
      toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen
      }
    }
  }
  </script>
  